import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=32c68152&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"
import style0 from "./taskList.vue?vue&type=style&index=0&id=32c68152&prod&lang=scss&scoped=true"
import style1 from "./taskList.vue?vue&type=style&index=1&id=32c68152&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c68152",
  null
  
)

export default component.exports